module.exports = __webpack_public_path__ + "img/fund-info.9fb0457c.png";